import { render } from "./NavsButton.vue?vue&type=template&id=0e517672&scoped=true"
import script from "./NavsButton.vue?vue&type=script&lang=js"
export * from "./NavsButton.vue?vue&type=script&lang=js"

import "./NavsButton.vue?vue&type=style&index=0&id=0e517672&lang=sass&scoped=true"

import exportComponent from "/Users/liyunchen/Documents/Salute Project/BMW_4GC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e517672"]])

export default __exports__